import React, { type ReactNode } from 'react';

import styled from 'styled-components';

import type { IBadgeProps } from '@sine/sine-ui-components';
import { Badge, Heading, Spacer, Text, colors, spacing } from '@sine/sine-ui-components';

export interface IPageHeaderProps {
  /** Optionally place class on outer component. */
  className?: string;
  /** Text to use for the title. */
  title: string;
  /** Action text for the card */
  description?: ReactNode;
  /** Actions included in the page header */
  actions?: ReactNode;
  /** Control badge show */
  badge?: IBadgeProps & { text: string };
}

const Container = styled.div`
  display: flex;
  background: ${colors.white};
  padding: ${spacing(3)};
`;

const Header = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;

const Title = styled(Heading)`
  margin: 0;
`;

const Description = styled(Text)`
  display: block;
  margin-top: ${spacing(1)};
`;

const ActionContainer = styled.div`
  display: flex;
  align-items: center;
`;

const HeadingDiv = styled.div`
  display: flex;
  align-items: center;
`;

const StyledBadge = styled(Badge)`
  margin-bottom: -5px;
`;

export function PageHeader({ className, title, description, actions, badge }: IPageHeaderProps) {
  return (
    <Container className={className} data-st-ext='page-header'>
      <Header>
        <HeadingDiv>
          <Title type='h1' data-st-ext='title'>
            {title}
          </Title>
          <Spacer width={1.5} />
          {badge && (
            <StyledBadge variant={badge.variant || 'info'} theme={badge.variant || 'dark'} icon={badge.icon}>
              {badge.text}
            </StyledBadge>
          )}
        </HeadingDiv>

        {description && <Description data-st-ext='description'>{description}</Description>}
      </Header>

      {actions && <ActionContainer>{actions}</ActionContainer>}
    </Container>
  );
}
